<app-tvshop-header [titleKey]="'eos-tv-shop-ii.title.netflix-services-option-header-' + omapiId.toLowerCase()"></app-tvshop-header>

<div class="netflix-services-details standalone-flavor-container">
    <div class="standalone-flavor-content" #standaloneFlavors>

      <div class="standalone-flavor-order-body">
        <div *ngFor="let option of standaloneOptions; let i = index">
          <app-standalone-flavor-option [orderOption]="option"
                                        [x]="i"
                                        [y]="0"
                                        [omapiId]="option?.omapiId"
                                        [pack]="option?.pack"
                                        [badgeCopyKey]="'eos-tv-shop-ii.badge.netflix-flavor'"
                                        (emitOrderProduct)="onEmitOrderProduct($event)"
                                        (emitOnBack)="onBack()"
          ></app-standalone-flavor-option>
        </div>
      </div>

    </div>
</div>

<app-ordering-modal-manager [order]="order" #orderModal></app-ordering-modal-manager>
